import { AmplitudeEvent } from "./AmplitudeEvent";
import { isValid as isValidGoalType } from "@/constants/GoalType";

export class GoalTypeSelectedEvent extends AmplitudeEvent {
	constructor( goalType ) {
		super();
		if ( !isValidGoalType( goalType ) ) {
			throw new Error( `${ goalType } is not a valid goal type` );
		}
		this.name = "Goal Type Selected";
		this.eventProperties.state = goalType;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/GoalTypeSelectedEvent.js